import wrapFormulary from '../../../formulary/wrapFormulary';

import formulary from './formulary';

export default wrapFormulary(formulary);
